module.exports = __webpack_public_path__ + "media/img/event/speakers/Yasmin-Sarwar-3bce69e31d2bf9d8beb5a5f7fc3869f6.jpg";